import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from "recharts";
import "../../../styles/home1.css";

const vendorTrendsData = [
  { year: "2019", value: 20 },
  { year: "2020", value: 35 },
  { year: "2021", value: 25 },
  { year: "2022", value: 30 },
  { year: "2023", value: 45 },
  { year: "2024", value: 40 },
  { year: "2025", value: 55 }
];

export default function VendorsBarChart() {
  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body">
        <h6 className="card-title fw-bold mb-3">Vendors</h6>

        <div style={{ width: "100%", height: 200 }}>
          <ResponsiveContainer>
            <BarChart data={vendorTrendsData}>
              <Bar dataKey="value" fill="#8884d8" radius={[4,4,0,0]} barSize={20}/>
              <XAxis dataKey="year" tick={{fontSize:10}} axisLine={false} tickLine={false}/>
              <YAxis tick={{fontSize:10}} axisLine={false} tickLine={false}/>
            </BarChart>
          </ResponsiveContainer>
        </div>

      </div>
    </div>
  );
}  